import React, { useMemo } from 'react';
import ChatAssistView from '../components/ChatAssistView';
import ChatAssistV2 from '../components/NewVersion/ChatAssistV2';
import { Redirect } from 'react-router-dom';
import { useShouldShowChatAssistRedirect } from 'features/chatAssist/ChatAssistHook';
import useGetClientByEmailQuery from '../newServices/queries/useGetClientByEmail';
import { useSalesAssistStore } from '../ChatAssist.store';
import Organization from 'infrastructure/Organization';

const ChatAssist = () => {
  const { loading, enabled: isEnabled, version, useNewApi } = useShouldShowChatAssistRedirect();

  const isProduction = process.env.REACT_APP_ENV === 'Production';

  let email = isProduction
    ? Organization.getSelectedOrg()?.owner
    : process.env.REACT_APP_BASE_EMAIL;
  const { client_id, clientError } = useSalesAssistStore();

  const enabledUseNewApi = useMemo(
    () => useNewApi && email && !clientError,
    [useNewApi, email, clientError]
  );

  const { isFetching: isLoadingClientData } = useGetClientByEmailQuery({
    enabled: enabledUseNewApi && client_id === '',
    email,
  });

  if (loading || isLoadingClientData) return null;

  return isEnabled ? (
    version === 1 ? (
      <ChatAssistView />
    ) : (
      <ChatAssistV2 useNewApi={enabledUseNewApi} />
    )
  ) : (
    <Redirect to="/" />
  );
};

export default ChatAssist;
